module.exports = __webpack_public_path__ + "media/images/goutte-desktop-xl-cf974bfdd4a903f5d40d811eee2ec1e5.jpg";